import React from "react";
import Link from "next/link";
import useDialog from "./useDialog";

/**
 * 헤더 "해봄 체험하기" → 요원 유형 선택 (2026-09-12 체험하기 개편판, 포스터형 다크 모달).
 * `?new=1` 쿼리가 있을 때만 쓰이고, 없으면 기존 LandingPlayModal 이 뜬다(useNewPlayFlow). 앱 Header 의
 * ExhibitionPosterModal 과 같은 구성. 스타일은 LandingStyles 의 `.modal-play` 아래.
 *
 * 여기서 이동하는 `/play3`(14세 미만)·`/play4`(14세 이상)은 로그인 없이 들어오는 것이
 * 정책입니다. 두 페이지에는 인증 가드를 붙이면 안 됩니다.
 */
export default function LandingPlayPosterModal({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  const { ref, onBackdropClick } = useDialog(open, onClose);

  return (
    <dialog
      className="modal modal-play"
      ref={ref}
      onClick={onBackdropClick}
      aria-labelledby="play-title"
    >
      <div className="modal-card">
        <button type="button" className="modal-close" onClick={onClose} aria-label="닫기">
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden="true">
            <path
              d="m5 5 10 10M15 5 5 15"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
            />
          </svg>
        </button>

        <div className="play-head">
          <h2 className="play-title" id="play-title">
            코딩이가 사라졌다.
            <span className="play-title-sub">-요원 긴급 모집-</span>
          </h2>
          <p className="play-signal-line">
            마지막 신호 위치 : <strong className="play-signal">하나 연구실 B17</strong>
          </p>
        </div>

        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          className="play-poster"
          src="/images/exhibition/coding-missing-poster.png"
          alt="하나 연구실 B17. 경찰복을 입은 코딩이가 연구실에서 달려가고 있다."
          width={424}
          height={368}
        />

        <div className="play-foot">
          <p className="play-choose">요원 유형을 선택해 주세요</p>
          <div className="play-options">
            <Link className="play-option play-option-primary" href="/play3">
              <span className="play-option-text">
                <span className="play-option-title">14세 미만 · 학생 요원</span>
                <span className="play-option-desc">학교·학년·닉네임으로 등록해요</span>
              </span>
              <ArrowIcon />
            </Link>
            <Link className="play-option play-option-secondary" href="/play4">
              <span className="play-option-text">
                <span className="play-option-title">14세 이상 · 일반 요원</span>
                <span className="play-option-desc">이름·소속·연락처로 등록해요</span>
              </span>
              <ArrowIcon />
            </Link>
          </div>
        </div>
      </div>
    </dialog>
  );
}

function ArrowIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
  );
}
